import { useEffect, useLayoutEffect, useRef } from 'react'
import { createRouteVisit } from '../lib/routeTelemetry'

export default function RouteTelemetryLifecycle({ pathname, routeKey, clubCode }) {
  const activeRef = useRef(null)
  const generationRef = useRef(0)

  useLayoutEffect(() => {
    if (activeRef.current?.pathname !== pathname) {
      activeRef.current?.visit.settle()
      activeRef.current = { pathname, visit: createRouteVisit({ routeKey, clubCode }) }
    }
    generationRef.current += 1
    activeRef.current.visit.mark('shell')
  }, [clubCode, pathname, routeKey])

  useEffect(() => () => {
    const generation = generationRef.current
    queueMicrotask(() => {
      if (generationRef.current === generation) activeRef.current?.visit.settle()
    })
  }, [])

  return null
}
